import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Calendar, Lock } from 'lucide-react';
export function Masterclass() {
  return <section className="py-24 lg:py-32 bg-gradient-to-b from-maroon to-[#2A0F24] text-white relative overflow-hidden" data-id="element-125">
      {/* Mercury / silver glow effects */}
      <div className="absolute top-0 left-0 w-full h-full opacity-[0.07] pointer-events-none" data-id="element-126">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-blush blur-[120px] rounded-full" data-id="element-127"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-silver blur-[120px] rounded-full" data-id="element-128"></div>
      </div>

      {/* Subtle metallic texture overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-silver/[0.02] via-transparent to-blush/[0.03] pointer-events-none" data-id="element-129"></div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="flex items-center space-x-4 mb-12 justify-center" data-id="element-132">
            <Lock className="w-6 h-6 text-blush" data-id="element-133" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blush via-silver-light to-blush font-bold tracking-[0.2em] uppercase text-sm" data-id="element-134">
              Upcoming Live Calls
            </span>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-135">
          <FadeIn delay={0.1} className="bg-white/[0.06] backdrop-blur-sm border border-blush/15 p-8 md:p-10 shadow-2xl flex flex-col h-full rounded-xl group hover:border-blush/30 transition-all duration-500" data-id="element-136">
            <div className="text-transparent bg-clip-text bg-gradient-to-r from-blush to-silver-light font-bold tracking-widest uppercase text-xs mb-4" data-id="element-137">
              First Live Call
            </div>
            <h3 className="text-3xl md:text-4xl font-bold mb-6 leading-tight text-white flex-grow" data-id="element-138">
              Ready for Funding: How to Find Capital, Programs, and the Right
              Rooms
            </h3>
            <div className="flex items-center text-cream mt-auto pt-6 border-t border-blush/10" data-id="element-139">
              <Calendar className="w-5 h-5 text-blush mr-3" data-id="element-140" />
              <span className="font-medium" data-id="element-141">Sunday, April 5 · 7:00 PM EST</span>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-white/[0.06] backdrop-blur-sm border border-blush/15 p-8 md:p-10 shadow-2xl flex flex-col h-full rounded-xl group hover:border-blush/30 transition-all duration-500" data-id="element-142">
            <div className="text-transparent bg-clip-text bg-gradient-to-r from-blush to-silver-light font-bold tracking-widest uppercase text-xs mb-4" data-id="element-143">
              Second Live Call
            </div>
            <h3 className="text-3xl md:text-4xl font-bold mb-6 leading-tight text-white flex-grow" data-id="element-144">
              Momentum Call: From Idea to Action (Hot Seats + Strategy)
            </h3>
            <div className="flex items-center text-cream mt-auto pt-6 border-t border-blush/10" data-id="element-145">
              <Calendar className="w-5 h-5 text-blush mr-3" data-id="element-146" />
              <span className="font-medium" data-id="element-147">
                Sunday, April 19 · 7:00 PM EST
              </span>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center" data-id="element-148">
          <a href="https://buy.stripe.com/bJe14m74m5KjgWygiMf3a07" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-gradient-to-r from-blush to-blush-light hover:from-blush-light hover:to-white text-maroon font-bold text-lg py-5 px-12 transition-all duration-300 shadow-[0_0_40px_rgba(242,181,200,0.15)] hover:shadow-[0_0_60px_rgba(242,181,200,0.25)] uppercase tracking-wide rounded-md text-center" data-id="element-149">
            Join FundHER Academy for $0.99
          </a>
        </FadeIn>
      </div>
    </section>;
}